module.exports = __webpack_public_path__ + "static/img/login-bg.a15395a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login/login-bg.jpg
// module id = xtrC
// module chunks = 1